import { render, staticRenderFns } from "./LicitacaoFornecedorDadosGerais.vue?vue&type=template&id=9091a934"
import script from "./LicitacaoFornecedorDadosGerais.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorDadosGerais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports